import { miscConstants } from '../../constants';
import { generalHelpers } from '../../helpers';
import { miscService } from '../../services';
import { Post } from '../../shared/types';
import { alertActions } from '..';
import { generalErrorHandler, resetAbortController } from '../utils';

export function listPosts() {
  return dispatch => {
    const ac = resetAbortController(miscConstants.LIST_POSTS_REQUEST);
    dispatch(request());
    dispatch(alertActions.clear());

    let getPostReadsRequest = () => miscService.getPostReads(ac.signal);
    if (!localStorage.user) {
      getPostReadsRequest = () =>
        Promise.resolve(JSON.parse(localStorage.getItem('readPost')) || []);
    }

    return Promise.all([
      miscService.listPosts(ac.signal),
      getPostReadsRequest(),
    ]).then(
      ([all, readIds]: [Post[], number[]]) => {
        const read = all.filter(post => readIds.includes(post.id));
        const unread = all.filter(post => !readIds.includes(post.id));
        dispatch(success(read, unread));
      },
      generalErrorHandler(dispatch, error =>
        dispatch(failure(error.toString()))
      )
    );
  };

  function request() {
    return { type: miscConstants.LIST_POSTS_REQUEST };
  }
  function success(read, unread) {
    return { type: miscConstants.LIST_POSTS_SUCCESS, read, unread };
  }
  function failure(error) {
    return { type: miscConstants.LIST_POSTS_FAILURE, error };
  }
}

export const readPost = (postId: number) => {
  if (localStorage.user) {
    // notifify server the post has been read
    miscService.readPost(undefined, postId).catch(generalHelpers.noop);
  }

  // save a copy locally for determining auto popup (especially for anonymous users)
  const readPostId = JSON.parse(localStorage.getItem('readPost')) || [];
  if (!readPostId.includes(postId)) {
    readPostId.push(postId);
  }
  localStorage.setItem('readPost', JSON.stringify(readPostId));

  return {
    type: miscConstants.READ_POST,
    postId,
  };
};
